import { useAppStore } from "@/data";
import { ThemeEnum } from "@/enums";
import { clientTheme } from "@/utils/Constant";
import { storeValue } from "@/utils/Storage";
import { createContext, ReactNode, useEffect } from "react";

export interface Theme {
  theme: ThemeEnum;
  toggleTheme: () => void;
  handleToggleTheme: () => void;
}

interface IProps {
  children: ReactNode;
}

const ThemeContext = createContext<Theme>({} as Theme);

const ThemeProvider = ({ children }: IProps) => {
  const { theme, toggleTheme } = useAppStore();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("theme-dark", theme === ThemeEnum.DARK);
    root.classList.toggle("theme-light", theme === ThemeEnum.LIGHT);
  }, [theme]);

  const handleToggleTheme = async () => {
    toggleTheme();
    const newTheme =
      theme === ThemeEnum.LIGHT ? ThemeEnum.DARK : ThemeEnum.LIGHT;
    storeValue(clientTheme, newTheme);
  };

  // Type guard to check if a string is a valid ThemeEnum value
  function isThemeEnum(value: string): value is ThemeEnum {
    return Object.values(ThemeEnum).includes(value as ThemeEnum);
  }

  const safeTheme = isThemeEnum(theme) ? theme : ThemeEnum.LIGHT; // Default to LIGHT if theme is not valid

  return (
    <ThemeContext.Provider value={{ theme: safeTheme, toggleTheme, handleToggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeProvider };

